var adjacent = require('./helper/adjacent');

module.exports = function succ(str) {
  return adjacent(str, -1);
};



//////////////////
// WEBPACK FOOTER
// ../.semaphore-cache/solaris-frontend/node_modules/underscore.string/pred.js
// module id = 825
// module chunks = 19